import React, { useState } from "react";
import { motion } from "framer-motion";
import { Header, Footer } from "../components/Chrome";
import { useSettings } from "../lib/settings";
import { api, formatError } from "../lib/api";
import { toast } from "sonner";

export default function Contact() {
  const { settings } = useSettings();
  const [f, setF] = useState({ name: "", email: "", phone: "", business: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/contact", f);
      toast.success(`Message sent — reference #${data.inquiry_no}. We'll respond within 1 business day.`);
      setF({ name: "", email: "", phone: "", business: "", message: "" });
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-paper text-ink">
      <Header />
      <section className="pt-28 md:pt-32 pb-12 px-6 md:px-12 lg:px-16" data-testid="contact-hero">
        <div className="overline text-black/50 mb-6">Contact</div>
        <h1 className="font-display text-[13vw] md:text-[10vw] lg:text-[9vw] uppercase leading-[0.85] tracking-tighter">
          Talk<br/>to <em className="font-editorial italic tracking-normal">us.</em>
        </h1>
      </section>

      <section className="px-6 md:px-12 lg:px-16 pb-20 md:pb-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5 space-y-8">
            {settings?.show_phone && settings?.phone && (
              <div>
                <div className="overline text-black/50 mb-2">Phone</div>
                <div className="font-display text-2xl md:text-3xl leading-none" data-testid="contact-phone-display">{settings.phone}</div>
              </div>
            )}
            {settings?.show_email && settings?.public_email && (
              <div>
                <div className="overline text-black/50 mb-2">Email</div>
                <div className="font-display text-2xl md:text-3xl leading-none break-words" data-testid="contact-email-display">{settings.public_email}</div>
              </div>
            )}
            {settings?.hours && (
              <div>
                <div className="overline text-black/50 mb-2">Hours</div>
                <div className="text-lg">{settings.hours}</div>
              </div>
            )}
            {settings?.address && (
              <div>
                <div className="overline text-black/50 mb-2">Location</div>
                <div className="text-lg">{settings.address}</div>
              </div>
            )}
          </div>
          <motion.form
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            onSubmit={submit}
            className="lg:col-span-6 lg:col-start-7 border border-ink p-6 md:p-10 hard-shadow space-y-4 bg-paper"
            data-testid="contact-form"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="overline block mb-2">Full name</label>
                <input required value={f.name} onChange={e => setF({ ...f, name: e.target.value })} className="field" data-testid="contact-name" />
              </div>
              <div>
                <label className="overline block mb-2">Email</label>
                <input required type="email" value={f.email} onChange={e => setF({ ...f, email: e.target.value })} className="field" data-testid="contact-email" />
              </div>
              <div>
                <label className="overline block mb-2">Phone</label>
                <input value={f.phone} onChange={e => setF({ ...f, phone: e.target.value })} className="field" data-testid="contact-phone" />
              </div>
              <div>
                <label className="overline block mb-2">Business</label>
                <input value={f.business} onChange={e => setF({ ...f, business: e.target.value })} className="field" data-testid="contact-business" />
              </div>
            </div>
            <div>
              <label className="overline block mb-2">Message</label>
              <textarea required rows={6} value={f.message} onChange={e => setF({ ...f, message: e.target.value })} className="field" data-testid="contact-message" />
            </div>
            <button disabled={busy} className="btn-primary w-full md:w-auto" data-testid="contact-submit">
              {busy ? "Sending…" : "Send message →"}
            </button>
          </motion.form>
        </div>
      </section>
      <Footer />
    </div>
  );
}
